import { call, put, select, takeLatest } from 'redux-saga/effects'
import { IOptionsResponse } from '../../../common/common.types'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

import { getServiceIdSelector } from '../../user/selectors'
import * as actions from '../store/options.actions'
import { ImagingUltrasoundService } from '../../procedures/imagingUltrasound/services/ImagingUltrasound.service'

export function* setImageUltrasoundTypeOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const imagingUltrasoundService = new ImagingUltrasoundService(serviceId)
  try {
    const response: IOptionsResponse = yield call([imagingUltrasoundService, imagingUltrasoundService.getTypeOptions])
    const { entity } = response
    yield put(actions.setImagingUltrasoundTypeOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`setImageUltrasoundTypeOptions() error: ${e}`))
  }
}
export function* setImageUltrasoundTypeOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], setImageUltrasoundTypeOptions)
}
